<template>
    <div class="d-none flex-row mt-2">
        <div class="justify-content-start">
            <a-badge color="#F64E60" v-if="unreadAnnouncements">
                <span class="material-icons" style="font-size: 20px !important">dvr</span>
            </a-badge>
            <span v-else class="material-icons" style="font-size: 20px !important">dvr</span>
        </div>
        <div class="justify-content-end pl-3 popoverFont cursorPointer" v-b-modal.announcement @click="showModal">
            {{ $t("message.announcements") }}
        </div>
        <Modal2
            id="announcement"
            v-if="isModalShow"
            @cancel="hideModal"
            :show-footer="false"
            :title="$t('message.announcements')"
        >
            <div class="d-block" v-if="!!announcements.length">
                <div class="accordion" role="tablist">
                    <b-card :key="index" no-body class="mb-1" v-for="(ann, index) of announcements">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-button class="w-100" block v-b-toggle="'accordion-' + index">
                                <span>{{ ann.languageContent[language.code].title_ }}</span>
                                -
                                <span>{{ $moment(ann.createdAt).format("LLL") }}</span>
                            </b-button>
                        </b-card-header>
                        <b-collapse :id="'accordion-' + index" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text v-html="ann.languageContent[language.code].description_" />
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>
            <div class="d-block text-center" v-else>
                <p class="my-4">{{ $t("message.noNewAnnouncement") }}</p>
            </div>
        </Modal2>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import _ from "lodash";
import Modal2 from "./common/Modal2.vue";

export default {
    name: "AnnouncementNotifications",
    data() {
        return {
            isModalShow: false,
        };
    },
    components: {
        Modal2,
    },
    computed: {
        ...mapState({
            announcements: (state) => _.sortBy(state.announcement.announcements.data, (x) => -x.createdAt),
            language: (state) => state.language.language,
        }),
        ...mapGetters({
            unreadAnnouncements: "announcement/unreadAnnouncements",
        }),
    },
    methods: {
        ...mapActions({
            setReadAnnouncement: "announcement/setReadAnnouncement",
        }),
        showModal() {
            this.isModalShow = true;
            this.setReadAnnouncement();
        },
        hideModal() {
            this.isModalShow = false;
        },
    },
};
</script>

<style scoped></style>
